import { getMarketplaceRequestKeyword } from './marketplaceKeywordSearch';

export const MARKETPLACE_KEYWORD_HISTORY_MAX = 5;
export const MARKETPLACE_KEYWORD_HISTORY_STORAGE_PREFIX = 'millet.marketplaceKeywordHistory';

export const getMarketplaceKeywordHistoryRole = (userType) => {
  if (userType === 'influencer') return 'influencer';
  if (userType === 'brand') return 'brand';
  return 'guest';
};

export const getMarketplaceKeywordHistoryKey = (userType) => (
  `${MARKETPLACE_KEYWORD_HISTORY_STORAGE_PREFIX}.${getMarketplaceKeywordHistoryRole(userType)}`
);

const sanitizeHistoryList = (value) => {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  const rows = [];
  value.forEach((entry) => {
    const keyword = getMarketplaceRequestKeyword(entry);
    if (!keyword) return;
    const key = keyword.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    rows.push(keyword);
  });
  return rows.slice(0, MARKETPLACE_KEYWORD_HISTORY_MAX);
};

export const readMarketplaceKeywordHistory = (userType) => {
  if (typeof window === 'undefined' || !window.localStorage) return [];
  try {
    const raw = window.localStorage.getItem(getMarketplaceKeywordHistoryKey(userType));
    if (!raw) return [];
    return sanitizeHistoryList(JSON.parse(raw));
  } catch (error) {
    return [];
  }
};

const writeMarketplaceKeywordHistory = (userType, keywords) => {
  const next = sanitizeHistoryList(keywords);
  if (typeof window === 'undefined' || !window.localStorage) {
    return next;
  }

  try {
    const key = getMarketplaceKeywordHistoryKey(userType);
    if (next.length === 0) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, JSON.stringify(next));
    }
  } catch (error) {
    // Ignore quota / private-mode write failures.
  }

  return next;
};

export const pushMarketplaceKeywordHistory = (userType, keyword) => {
  const normalized = getMarketplaceRequestKeyword(keyword);
  if (!normalized) return readMarketplaceKeywordHistory(userType);
  if (typeof window === 'undefined' || !window.localStorage) {
    return [normalized];
  }

  return writeMarketplaceKeywordHistory(userType, [
    normalized,
    ...readMarketplaceKeywordHistory(userType),
  ]);
};
